import { http } from './http_service';

// Get all
export function all(){
    return http().get('/lookup-values');
}
// Update
export function update(id, data){
    return http().put(`/lookup-values/${id}`, data)
}
